import { useSetRecoilState } from 'recoil';
import { toastState } from 'recoils/common/commonState';

/**
 * @desc 전역 토스트 사용을 위한 커스텀 훅
 */
const useToast = () => {
  const setToast = useSetRecoilState(toastState);

  /**
   * @param {string} severity - 'info', 'success', 'error'
   * @param {string} detail - 메시지 내용
   */
  const show = (severity, detail) => {
    setToast({
      visible: true,
      severity,
      detail,
    });
  };

  return { show };
};

export default useToast;
